<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardHeader>
                    <strong>Адреса Москва-Сити</strong>
                </CCardHeader>

                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <table class="table">
                            <thead>
                                <th></th>
                                <th>Имя</th>
                                <th>Адрес</th>
                                <th>Дом</th>
                                <th>Картинки</th>
                            </thead>
                            <Draggable v-model="list" tag="tbody">
                                <tr v-for="item in list" :key="item.id">
                                    <td>
                                        <CIcon
                                            :height="16"
                                            :content="cilCursorMove"
                                            class="handle" />
                                    </td>
                                    <td>
                                        <span
                                            class="text-purple-700 cursor-pointer hover:underline"
                                            @click="rowClicked(item)"
                                        >
                                            {{ item.name }}
                                        </span>
                                    </td>
                                    <td>
                                        {{ item.address }}
                                    </td>
                                    <td>
                                        {{ item.building }}
                                    </td>
                                    <td>
                                        <div class="relative flex flex-wrap w-full">
                                            <div
                                                v-for="item in item.pictures"
                                                :key="item"
                                                class="w-1/3 pr-2 pb-2"
                                            >
                                                <div
                                                    class="relative w-full overflow-hidden bg-no-repeat bg-cover rounded-md shadow-md group-hover"
                                                    :style="{
                                                        paddingTop: '100%',
                                                        backgroundImage: `url(${getStaticPath(item)})`,
                                                    }"
                                                ></div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </Draggable>
                        </table>
                    </template>
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        @click="
                            editModal.address = editModal.empty_address;
                            editModal.visible = true;
                        "
                    >Создать</CButton
                    >
                    <CButton
                        class="ml-4"
                        color="info"
                        @click="reorder"
                    >Сохранить расположение</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
        <CModal
            :title="
                editModal.address.id
                    ? 'Редактировать информацию о башне'
                    : 'Добавление информации о башне'
            "
            :show.sync="editModal.visible"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow form class="form-group mb-0">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label"
                            >Название башни</CCol
                            >
                            <CCol sm="9">
                                <CInput v-model="editModal.address.name" />
                            </CCol>
                        </CRow>
                        <CRow form class="form-group mb-0">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label"
                            >Сокращенно</CCol
                            >
                            <CCol sm="9">
                                <CInput v-model="editModal.address.short_name" />
                            </CCol>
                        </CRow>
                        <CRow form class="form-group mb-0">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Улица</CCol>
                            <CCol sm="9">
                                <CInput v-model="editModal.address.address" />
                            </CCol>
                        </CRow>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Дом</CCol>
                            <CCol sm="9">
                                <CInput v-model="editModal.address.building" />
                            </CCol>
                        </CRow>
                        <CRow form class="form-group">
                            <CCol sm="12"> Точка встречи </CCol>
                        </CRow>
                        <CRow form class="form-group mb-0">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Описание</CCol>
                            <CCol sm="9">
                                <CTextarea v-model="editModal.address.description" />
                            </CCol>
                        </CRow>
                        <CRow form class="form-group mb-0">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Вход</CCol>
                            <CCol sm="9">
                                <CInput v-model="editModal.address.address_details.entrance" />
                            </CCol>
                        </CRow>
                        <CRow form class="form-group mb-0">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Этаж</CCol>
                            <CCol sm="9">
                                <CInput v-model="editModal.address.address_details.floor" />
                            </CCol>
                        </CRow>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Офис</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="editModal.address.address_details.appartment"
                                />
                            </CCol>
                        </CRow>
                        <CRow form class="form-group mb-0">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Широта</CCol>
                            <CCol sm="9">
                                <CInput v-model="editModal.address.coordinates.latitude" />
                            </CCol>
                        </CRow>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Долгота</CCol>
                            <CCol sm="9">
                                <CInput v-model="editModal.address.coordinates.longitude" />
                            </CCol>
                        </CRow>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Картинки</CCol>
                            <CCol sm="9">
                                <div class="flex-1">
                                    <CInputFile
                                        custom
                                        placeholder="Выберите изображение"
                                        @change="uploadPicture"
                                    />

                                    <div class="relative flex flex-wrap w-full mt-2 -ml-2">
                                        <div
                                            v-for="item in editModal.address.pictures"
                                            :key="item"
                                            class="w-1/2 p-2"
                                        >
                                            <div
                                                class="relative w-full overflow-hidden bg-no-repeat bg-cover rounded-md shadow-md group-hover"
                                                :style="{
                                                    paddingTop: '100%',
                                                    backgroundImage: `url(${getStaticPath(item)})`,
                                                }"
                                            >
                                                <button
                                                    class="absolute top-0 right-0 w-8 h-8 text-xl text-white bg-red-400 rounded-bl-md"
                                                    @click="removePicture(item)"
                                                >
                                                    <CIcon :height="16" :content="cilTrash" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CCol>
                        </CRow>
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        v-if="editModal.address.id"
                        color="danger"
                        class="ml-3"
                        @click="deleteModalVisible = true"
                    >Удалить</CButton
                    >
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="editAddressSave()"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="editModal.visible = false"
                    >Отмена</CButton
                    >
                </div>
            </template>
        </CModal>
        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModalVisible"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>
                        Вы действительно хотите удалить информацию о данной башне? Это
                        действие нельзя будет отменить.
                    </p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModalVisible = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="deleteAddress"
                    >Удалить</CButton
                    >
                </div>
            </template>
        </CModal>
    </CRow>
</template>
<script>
    import to from 'await-to-js';
    import { cilTrash } from '@coreui/icons';
    import { cilCursorMove } from '@coreui/icons';
    import Draggable from 'vuedraggable';

    export default {
        name: 'Addresses',

        components: {
            Draggable,
        },

        data: () => ({
            loading: true,
            cilTrash,
            cilCursorMove,
            deleteModalVisible: false,
            editModal: {
                visible: false,
                address: {
                    name: null,
                    short_name: null,
                    address: null,
                    building: null,
                    address_details: {
                        entrance: null,
                        floor: null,
                        appartment: null,
                    },
                    coordinates: {
                        latitude: null,
                        longitude: null,
                    },
                    pictures: [],
                    id: null,
                },
                empty_address: {
                    name: null,
                    short_name: null,
                    address: null,
                    building: null,
                    address_details: {
                        entrance: null,
                        floor: null,
                        appartment: null,
                    },
                    coordinates: {
                        latitude: null,
                        longitude: null,
                    },
                    pictures: [],
                    id: null,
                },
            },
            list: [],
            errors: {
                pictures: [],
            },
        }),

        computed: {},

        async mounted() {
            await this.updateData();
            this.loading = false;
        },

        methods: {
            async updateData() {
                try {
                    const { data } = await this.axios.get('/address');
                    this.list = data;
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },

            getStaticPath(filename = '') {
                if (filename.startsWith('http')) {
                    return filename;
                }
                return `${process.env.VUE_APP_STATIC_BASE_URL}/${filename}`;
            },

            async uploadPicture(FileList) {
                const form = new FormData();
                form.append('file', FileList[0]);

                const [err, result] = await to(this.axios.post('/files/upload', form));

                if (err) {
                    this.$root.$emit('showError', 'Ошибка. Не удалось загрузить картинку.');
                }
                if (!this.editModal.address.pictures) {
                    this.editModal.address.pictures = [];
                }
                this.editModal.address.pictures.push(result.data.filename);
            },

            removePicture(url) {
                const idx = this.editModal.address.pictures.indexOf(url);

                if (idx !== -1) {
                    this.editModal.address.pictures.splice(idx, 1);
                }
            },

            async editAddressSave() {
                if (this.editModal.address.id) {
                    await this.axios.put(
                        `/address/${this.editModal.address.id}`,
                        this.editModal.address
                    );
                } else {
                    await this.axios.post('/address/', this.editModal.address);
                }
                this.editModal.visible = false;
                this.updateData();
            },

            async deleteAddress() {
                this.editModal.visible = false;
                this.deleteModalVisible = false;
                await this.axios.delete(`/address/${this.editModal.address.id}`);
                this.editModal.address = {
                    name: null,
                    address: null,
                    building: null,
                    address_details: {
                        entrance: null,
                        floor: null,
                        appartment: null,
                    },
                    coordinates: {
                        latitude: null,
                        longitude: null,
                    },
                    pictures: [],
                    id: null,
                };
                this.updateData();
            },

            rowClicked(item) {
                this.editModal.visible = true;
                this.editModal.address = item;
                this.editModal.address.address_details = item.address_details
                    ? item.address_details
                    : this.editModal.empty_address.address_details;
                this.editModal.address.coordinates = item.coordinates
                    ? item.coordinates
                    : this.editModal.empty_address.coordinates;
                this.editModal.address.pictures = item.pictures
                    ? item.pictures
                    : this.editModal.empty_address.pictures;
            },

            async reorder() {
                try {
                    const payload = {
                        reorder: this.list.map((item, idx) => ({ id: item.id, position: idx + 1, name: item.name }))
                    };
                    const { data } = await this.axios.post('/address/reorder', payload)
                } catch (err) {
                    this.$root.$emit('showError', 'Не удалось сохранить расположение.');
                }
            },
        },
    };
</script>
<style scoped>
td .handle {
  cursor: pointer;
}
</style>
